module.exports = __webpack_public_path__ + "img/expand_icon.7e1ac370.svg";